var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-tabs',{ref:"dynamicTabs",attrs:{"tabs-id":"user-account-tabs","tabs":_vm.tabs}})
}
var staticRenderFns = []

export { render, staticRenderFns }